import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    standalone: false,
    selector: 'sm-overview-box',
    templateUrl: './sm-overview-box.component.html',
    styleUrls: ['./sm-overview-box.component.scss']
})
export class SmOverviewBoxComponent {
    @Input() 
    count: number
    @Input() 
    text: string;
    @Input() 
    icon: string;
    @Input() 
    boxColor: string;
    @Output() 
    click2 = new EventEmitter<void>();
    
    onClick(event: any): void { 
        this.click2.emit();
        event.preventDefault(); 
    }

    htmlColor(): string {
        return this.boxColor?.startsWith("#") ? this.boxColor : Utils.toColorHexString(Utils.getMaterialColors()[Utils.toNumber(this.boxColor)]);
    }
}
